(() => {

    function resizeVideo(video){

        if(!video || !video.videoWidth) return;

        const ratio = video.videoWidth / video.videoHeight;

        video.style.width = "";
        video.style.height = "";
        video.style.maxWidth = "";
        video.style.maxHeight = "";

        // Querformat
        if(ratio >= 1){

            video.style.maxWidth = "88vw";
            video.style.maxHeight = "82vh";

        }

        // Hochformat
        else{

            video.style.maxWidth = "58vw";
            video.style.maxHeight = "88vh";

        }

        video.style.objectFit = "contain";
        video.style.display = "block";
        video.style.margin = "auto";

    }

    function init(){

        document.querySelectorAll(".pswp__hotspots-wrap video").forEach(video=>{

            if(video.dataset.lookfyReady) return;

            video.dataset.lookfyReady="1";

            if(video.readyState>=1){
                resizeVideo(video);
            }

            video.addEventListener("loadedmetadata",()=>{
                resizeVideo(video);
            });

            window.addEventListener("resize",()=>{
                resizeVideo(video);
            });

        });

    }

    new MutationObserver(init).observe(document.body,{
        childList:true,
        subtree:true
    });

    init();

})();